import { DividerSizeMedium } from "@wix/wix-ui-icons-common";
import React, { useContext, useState } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import {
  getIsModalOpen,
  useModalService,
  useModalState
} from "./../../../ricos-modals/modal-service-provider.js";
import { DividerData_Width } from "./../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { DropdownButton } from "./../../../_shared/dropdown-button.js";
import { DIVIDER_BUTTONS } from "../../const.js";
import DividerSizePanel from "../modals/DividerSizePanel.js";
import { dividerSizeData } from "./dividerButtonsData.js";
const DividerSizeButton = ({ toolbarItem, dataHook }) => {
  const { isMobile, t } = useContext(RicosContext);
  const modalService = useModalService();
  const isModalOpen = useModalState(getIsModalOpen(DIVIDER_BUTTONS.size));
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedSize = () => toolbarItem?.attributes.nodeSize || DividerData_Width.LARGE;
  const selectedSize = dividerSizeData.find(({ commandKey }) => commandKey === getSelectedSize());
  const icon = selectedSize?.icon || DividerSizeMedium;
  const onClick = () => {
    modalService.isModalOpen(DIVIDER_BUTTONS.size) ? modalService.closeModal(DIVIDER_BUTTONS.size) : modalService.openModal({
      id: DIVIDER_BUTTONS.size,
      Component: DividerSizePanel,
      componentProps: {
        toolbarItem,
        getSelectedSize
      },
      layout: isMobile ? "drawer" : "floating",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: isModalOpen,
      onClick,
      ref: setReferenceElement,
      icon,
      tooltip: t("ButtonModal_Size_Section"),
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  DividerSizeButton
};
//# sourceMappingURL=DividerSizeButton.js.map
